export default {
  "cancel-success": {
    EN: "Successfully cancelled Opportunity",
  },
  "cancel-failure": {
    EN: "Failed to cancel the Opportunity",
  },
  "create-failure": {
    EN: "Failed to create Opportunity.",
  },
  "create-success": {
    EN: "Successfully created Opportunity.",
  },
  "load-failure": {
    EN: "Failed to load the Opportunity details. Please try again later.",
  },
  "proposal-success": {
    EN: "Successfully created Proposal.",
  },
  "proposal-failure": {
    EN: "Failed to create Proposal.",
  },
  "update-success": {
    EN: "Opportunity updated successfully!",
  },
  "update-failure": {
    EN: "Could not update Opportunity",
  },
  "create-status-failure": {
    EN: "Could not create opportunity status",
  },
  "create-status-success": {
    EN: "Opportunity status created succesfully!",
  },
  "delete-failure": {
    EN: "Could not delete opportunity",
  },
  "delete-success": {
    EN: "Opportunity deleted!",
  },
};
